/**
 * Deterministic diaper-model → color mapping.
 * Only models with real names from the API get distinct colors.
 * Unnamed / error / shorted models all share a single "invalid" color.
 */

export const INVALID_MODEL_COLOR = '#dc2626';

const MODEL_COLOR_MAP: Record<number, string> = {
  // --- High-volume named models (maximally distinct) ---
  23: '#2563eb', // strong blue   — M-L4       (~33 %)
  29: '#16a34a', // green         — L-XL4      (~20 %)
  26: '#ea580c', // orange        — San-10     (~15 %)
  15: '#9333ea', // purple        — M-L2       (~6 %)
  30: '#0d9488', // teal          — San-7      (~4 %)
  27: '#db2777', // magenta       — L-XL2      (~3.5 %)

  // --- Lower-volume named models ---
  14: '#e11d48', // rose          — S2
  28: '#115e59', // dark teal     — San-6

  // --- Legacy named models ---
  3:  '#92400e', // brown         — M-L2 (old)
  6:  '#4d7c0f', // olive         — L-XL2 (old)
  7:  '#0284c7', // sky blue      — XL2
  17: '#a16207', // warm brown    — L-XL4 (old)
  19: '#1e40af', // navy          — M-L4 (old)
  24: '#06b6d4', // cyan          — XL4
};

/**
 * Returns a deterministic color for a model code.
 * Named models get a distinct hue; unnamed / error / shorted models
 * all return `INVALID_MODEL_COLOR` (red).
 */
export function getModelColor(modelCode: number): string {
  return MODEL_COLOR_MAP[modelCode] ?? INVALID_MODEL_COLOR;
}

export function getModelBgColor(modelCode: number): string {
  const hex = getModelColor(modelCode);
  return hex + '18';
}
